export const aboutPageSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '关于我们 - 2pg·com 品牌介绍与联系方式',
    url: 'https://2pg.com/about',
    description: '了解2pg·com的品牌故事、平台优势、信誉保障以及联系方式。我们致力于为每一位用户提供安全、便捷、丰富的游戏娱乐体验。',
    isPartOf: {
      '@type': 'WebSite',
      name: '2pg·com',
      url: 'https://2pg.com',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '2pg·com',
    url: 'https://2pg.com',
    logo: 'https://2pg.com/logo.png',
    description: '值得信赖的在线游戏娱乐平台，简单快捷的登录注册，安全加密保障，千万用户信赖之选。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: '客户服务',
      email: 'support@2pg.com',
      availableLanguage: ['Chinese'],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://2pg.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'https://2pg.com/about',
      },
    ],
  },
];